import React, {useState, useRef, useEffect} from 'react';
import post from '../utils/post.js';
import FormText from './FormText.js';
import ConfirmPopup from './ConfirmPopup.js';
import FormColor from './FormColor.js';
import usePopupAnimation from '../utils/usePopupAnimation.js';

export default function MusclegroupEdit({showEdit, closeEdit, updateMusclegroupRowEdit, updateMusclegroupRowDelete, data, targetUsrId = 0}) {
	const popupAnimationMs = 300;
	const [loading, setLoading] = useState(false);
	const [name, setName] = useState('');
	const [nameError, setNameError] = useState('');
	const [color, setColor] = useState('#999900');
	const [colorError, setColorError] = useState('');
	const [showConfirmPopup, setShowConfirmPopup] = useState(false);

	const nameRef = useRef(null);
	const colorRef = useRef(null);
	const {shouldRender, isClosing} = usePopupAnimation(showEdit, popupAnimationMs);

	useEffect(() => {
		setName('');
	}, [showEdit]);

	useEffect(() => {
		setName(data.NAME || '');
		setColor(data.COLOR || '#999900');

		setNameError('');
		setColorError('');
	}, [data]);

	const handleSubmit = (e) => {
		e.preventDefault();

		setNameError('');

		let localError = 0;

		if (!name) {
			localError = 1;
			setNameError('povinné');
			nameRef.current.focus();
		}

		if (localError === 0) {
			setLoading(true);
			const payload = {NAME: name, COLOR: color, ID: data.ID};

			if (targetUsrId > 0) {
				payload.USRID = targetUsrId;
			}

			post('saveMusclegroupOld', payload)
				.then((res) => {
					closeEdit();

					if (res.data === 1) {
						updateMusclegroupRowEdit({ID: data.ID, NAME: name, COLOR: color, data_graph: {data: data.data_graph.data, labels: data.data_graph.labels}});
					}

					setLoading(false);
				})
				.catch((error) => {
					console.error(error);
					setLoading(false);
				});
		}
	};

	const handleConfirmPopup = (e) => {
		e.preventDefault();
		setShowConfirmPopup(true);
	};

	const closeConfirmPopup = () => {
		setShowConfirmPopup(false);
	};

	const deleteConfirmPopup = () => {
		setLoading(true);
		const payload = {ID: data.ID};

		if (targetUsrId > 0) {
			payload.USRID = targetUsrId;
		}

		post('deleteMusclegroup', payload)
			.then((res) => {
				closeConfirmPopup();
				closeEdit();
				updateMusclegroupRowDelete(data.ID);
				setLoading(false);
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	return (
		<>
			<ConfirmPopup showConfirmPopup={showConfirmPopup} showButtonDelete deleteConfirmPopup={deleteConfirmPopup} closeConfirmPopup={closeConfirmPopup} infoHeader="Smazání záznamu" infoMain="Opravdu chceš smazat tento záznam?" />

			{shouldRender ? (
				<div className={`popup${isClosing ? ' popup--closing' : ''}`}>
					<div className={`popup_content${isClosing ? ' popup_content--closing' : ''}`}>
						<form method="POST" onSubmit={handleSubmit}>
							<div className="popup_content_in_head">
								<div className="popup_content_in_head_in">Editace svalové partie</div>
								<img
									alt=""
									className="popup_content_in_head_in-close"
									onClick={() => {
										closeEdit();
									}}
								/>
							</div>
							<div className="popup_content_in_body">
								<div className="popup_content_in_body_in">
									<FormText type="text" label="Název" value={name} setValue={setName} ref={nameRef} error={nameError} />
									<div className="zero h0" />

									<FormColor type="text" label="Barva" value={color} setValue={setColor} ref={colorRef} error={colorError} />
									<div className="zero h0" />
								</div>
							</div>
							<div className="popup_content_in_foot">
								<div className="popup_content_in_foot_in">
									<input type="submit" name="button_save" value="Uložit" className="button green mr_2" disabled={loading} />
									<button
										type="button"
										className="button red mr_2"
										onClick={(e) => {
											handleConfirmPopup(e);
										}}
									>
										Smazat
									</button>
									<button
										type="button"
										className="button"
										onClick={() => {
											closeEdit();
										}}
									>
										Zpět
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			) : (
				''
			)}
		</>
	);
}
